module.exports = "/images/main_logo.png?febe7ec8af1cdce252da7a8fdc4bf0b4";